module.exports = __webpack_public_path__ + "static/media/Cougar460_2c.1aa9e26b.svg";